import {Component, OnDestroy, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState} from '@store/state/app.state';
import {ConfigState} from '@store/state/config.state';
import {Observable, Subject} from 'rxjs';
import {NumberFormat} from '@iw-shop/core/functions/number-format';
import {DeliveryTourService} from "@iw-shop/delivery-tour/services/delivery-tour.service";
import {takeUntil} from "rxjs/operators";
import {ApiDeliveryTour} from "@api/delivery-tours";

@Component({
    selector: 'iw-shop-delivery-tour-next-delivery-date',
    standalone: false,
    templateUrl: './delivery-tour-next-delivery-dates.component.html',
    styleUrls: ['./delivery-tour-next-delivery-dates.component.scss']
})
export class DeliveryTourNextDeliveryDatesComponent implements OnInit, OnDestroy {

    destroy$: Subject<boolean> = new Subject<boolean>();
    config$: Observable<ConfigState>;

    loading: boolean = false;
    shoppingCartArticles: number = 0;
    priceMode: 'net' | 'gross' = 'gross';

    nextDeliveryTours: { date: Date, periods: string[] }[] = [];
    selectedDeliveryTour: ApiDeliveryTour | null = null;

    constructor(private store: Store<AppState>, private deliveryTourService: DeliveryTourService) {
        this.config$ = this.store.select(state => state.config);

        this.deliveryTourService.getSelectedDeliveryTour()
            .pipe(
                takeUntil(this.destroy$)
            ).subscribe(
            {
                next: (r) => {
                    this.loading = false;
                    if(r){
                        this.load();
                        this.loading = false;
                    }

                }
            }
        );
    }


    ngOnInit() {
    }

    load() {
        this.nextDeliveryTours = this.deliveryTourService.getNextDeliveryTours();
        this.selectedDeliveryTour = this.deliveryTourService.getSelectedDeliveryTour().value;
        this.shoppingCartArticles = this.deliveryTourService.getShoppingCartArticles(this.deliveryTourService.getSelectedDeliveryTour()?.value?.minimumArticles?.excludedGroups ?? []);
    }


    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }

    protected readonly NumberFormat = NumberFormat;
}
